<template>
  <div class="w-full overflow-y-auto">
    <div class="w-full max-w-[1160px] min-w-[463px] pt-[36px] px-[32px] flex flex-col mx-auto min-h-[100vh]">

    <!-- Header -->
    <PageHeader
      :title="templateTitle || 'Шаблон задачи КЗС'"
      subtitle="Шаблоны задач КЗС"
      withBackBtn
      @on-back="backBtnHandler"
    />
    <!-- End Header -->
    <!-- Content -->
    <VSkeleton v-if="isLoading" class="w-full h-[228px] rounded-[8px]"/>
    <div v-else-if="isError" class="flex-1 min-h-0 flex">
      <v-placeholder
        message="Что-то пошло не так"
        description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
        :icon="{ name: 'xl/mood-confuzed' }"
        :retry="{ label: 'Повторить запрос', handler: fetchTemplate }"
        class="!min-h-[70vh] h-full w-full !p-[24px]"
      >
        <template #footer>
          <p class="text-14-reg-400">Позвонить в техподдержку</p>
          <a
            class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
            href="tel:88005000299"
            >8 800 500-02-99</a>
          </template>
        </v-placeholder>
      </div>

      <div v-else>
        <div v-if="isEditMode">
          <KzsTemplateForm
          :template="template"
          editMode
          :backBtnActive="backBtnActive"
          @updateTemplate="updateTemplateHandler"
          @update:backBtnActive="updateBackBtnActive"
          @cancel="cancelHandler"
          />
        </div>
        <div v-else class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
          <div class="flex flex-col gap-y-[8px]">
            <div class="flex gap-x-[2px] text-v-ui-text-monochrome title-16-medium-500">Описание</div>
            <p class="text-v-ui-text-monochrome-80 massive-16-reg">{{ template?.description || '-' }}</p>
          </div>
          <div class="flex flex-col gap-y-[8px]">
            <div class="flex gap-x-[2px] text-v-ui-text-monochrome title-16-medium-500">Приоритет</div>
            <p class="text-v-ui-text-monochrome-80 massive-16-reg">{{ priorityTitle }}</p>
          </div>
          <div class="flex flex-col gap-y-[8px]">
            <div class="flex gap-x-[2px] text-v-ui-text-monochrome title-16-medium-500">Время на выполнение задачи, дни</div>
            <p class="text-v-ui-text-monochrome-80 massive-16-reg">{{ getDaysFromMinutes(template?.slaMinutes) || '-' }}</p>
          </div>
          <div class="flex flex-col gap-y-[8px]">
            <div class="flex gap-x-[2px] text-v-ui-text-monochrome title-16-medium-500">Задача по шаблону доступна</div>
            <p class="text-v-ui-text-monochrome-80 massive-16-reg">{{ getRoleTitle(template?.roles) || '-' }}</p>
          </div>
          <div class="flex justify-start gap-x-[8px]">
            <VButton size="m" @click="isEditMode = true" label="Редактировать" />
          </div>
        </div>
      </div>
    <!-- End Content -->
    </div>
  </div>
</template>

<script>
import kzsTemplateService from '@/services/kzs/kzs-templates/kzs-template.service';
import {VSkeleton, VPlaceholder, VButton} from '@gostelemed.front/rt-doctis.designsystem';
import KzsTemplateForm from '@/components/Kzs/Templates/KzsTemplateForm';
import PageHeader from '@/components/common/PageHeader';
export default {
  name: 'KzsTemplatesView',
  page: {
    title: 'CRM Doctis - Шаблоны задач КЗС',
  },
  components: {
    VSkeleton,
    VPlaceholder,
    VButton,
    KzsTemplateForm,
    PageHeader,
  },
  async mounted() {
    await this.fetchTemplate();
  },
  data() {
    return {
      template: null,
      isLoading: true,
      isError: false,
      isEditMode: false,
      templateTitle: null,
      backBtnActive: false,
    }
  },
  computed: {
    priorityTitle() {
      const map = {
        0: 'Низкий',
        1: 'Средний',
        2: 'Высокий',
        3: 'Критический',

      };
      return map[this.template?.priority] || '-';
    }
  },
  methods: {
    backBtnHandler() {
      if(this.isEditMode) {
        this.backBtnActive = true;
      } else {
        this.$router.push('/remote-monitoring/kzs/templates');
      }
    },
    updateTemplateHandler(updatedTemplate) {
      this.template = updatedTemplate;
      this.templateTitle = this.template.name;
      this.isEditMode = false;
    },
    updateBackBtnActive(value) {
      this.backBtnActive = value;
    },
    async cancelHandler() {
      try {
        await this.fetchTemplate();
      } catch (error) {
        console.error('Ошибка при получении шаблона задачи КЗС:', error);
      }
      this.isEditMode = false;
      this.backBtnActive = false;
    },

    getDaysFromMinutes(minutes) {
      if(!minutes) return '-';
      const days = Math.floor(minutes / 1440);
      if(days === 0) {
        return '< 1';
      }
      return `${days}`;
    },
    getRoleTitle(roles) {
      if(!roles) return '-';

      const rolesMap = {
        1: 'Лечащему врачу',
        2: 'Врачу-специалисту',
        3: 'Медицинскому работнику колл-центра',
      }

      return rolesMap[roles[0]] || '-';
    },
    async fetchTemplate() {
      const id = this.$route.params.id;
      if (!id) {
        this.$router.push('/remote-monitoring/kzs/templates');
        return;
      }
      try {
        const response = await kzsTemplateService.getKzsTemplateById(id);
        if (response) {
          this.template = response;
          this.templateTitle = this.template.name;
          this.isLoading = false;
        }
      } catch (error) {
        this.isError = true;
        console.error('Ошибка при получении шаблона задачи КЗС:', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
}
</script>
